import { render, staticRenderFns } from "./ProductPointSlider.vue?vue&type=template&id=f70c2cb4&scoped=true&"
import script from "./ProductPointSlider.vue?vue&type=script&lang=js&"
export * from "./ProductPointSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductPointSlider.vue?vue&type=style&index=0&id=f70c2cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c2cb4",
  null
  
)

export default component.exports